import { createApi } from 'api/common/createApi'
import config, { API_TYPES } from 'constants/api-config'

export const userDetailsApi = createApi({
  baseURL: '/_apps/user-details/api',
})

export const facadeApi = createApi({
  baseURL: '/api',
})

export const matchAndThriveApi = createApi({
  baseURL: config[API_TYPES.MT_API_URL],
})

export const colliderTCCCApi = createApi({
  baseURL: config[API_TYPES.WORKFRONT_API],
})
